export const STORAGE_KEYS = {
  accessToken: 'lumen-meds-membership-access-token',
  userInfo: 'lumen-meds-membership-user-info',
  activeOrderId: 'lumen-meds-membership-active-order-id',
  loginFromCRM: 'lumen-meds-membership-login-from-crm',
};
